<section class="twoway-command-details">
  @if (commandTitle()) {
    <h6 class="twoway-command-details__title">{{ commandTitle() }}</h6>
  }

  <section class="twoway-command-details-data-wrapper">
    @for (row of commandDetailRows(); track row.left.titleKey) {
      <div class="twoway-command-details-data-row f-center">
        <div class="twoway-command-details-data-item">
          <div class="subtitle">{{ row.left.titleKey | translate }}</div>
          <div class="twoway-command-details-data-item__value">
            @if (row.left.bubbleValue) {
              <span [uiBubble]="row.left.bubbleValue">{{ row.left.value | translate }}</span>
            } @else {
              <span>{{ row.left.value | translate }}</span>
            }
          </div>
        </div>
        @if (row.right) {
          <div class="twoway-command-details-data-item">
            <div class="subtitle">{{ row.right.titleKey | translate }}</div>
            <div class="twoway-command-details-data-item__value">
              @if (row.right.bubbleValue) {
                <span [uiBubble]="row.right.bubbleValue">{{ row.right.value | translate }}</span>
              } @else {
                <span>{{ row.right.value | translate }}</span>
              }
            </div>
          </div>
        }
      </div>
    }
    <h6>{{ deviceTitle | translate }}</h6>
  </section>
  <aos-app-device-side-panel
    [basicData]="basicData()"
    [customerCardData]="customerCardData()"
    [isMap]="isMap()"
    [deviceCardData]="deviceCardData()"
  ></aos-app-device-side-panel>
</section>
